<div class="header">
  <div mat-dialog-title class="dialog-title">
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <img
    src="../../../../assets/images/logo-kaleidolab.png"
    alt=""
    class="logo"
  />
</div>
<!-- <div class="equisde">
  <i class="fas fa-times"></i>
</div> -->

<div class="principal-container">
  <div *ngIf="showLogin" class="option-auth-login" (click)="getOptionSeleted('login')">
    Iniciar sesión
    <div
      [ngClass]="{ 'line-option-login': this.activeOption === 'login' }"
    ></div>
  </div>

  <div *ngIf="showRegister" class="option-auth-register" (click)="getOptionSeleted('register')">
    Registrarse
    <!-- <div *ngIf="showRegister"
      [ngClass]="{ 'line-option-register': this.activeOption === 'register' }"
    ></div> -->
  </div>

  <div *ngIf="showCompany" class="option-auth-login">
    Agregar empresa
    <!-- <div *ngIf="showRegister"
      [ngClass]="{ 'line-option-register': this.activeOption === 'register' }"
    ></div> -->
  </div>


  <!-- Inicio flujo login -->
  <div *ngIf="showLogin">
    <div class="login-container">
      <form [formGroup]="loginForm">
        <mat-form-field appearance="legacy" class="email" style="margin-top: 30px;">
          <mat-label>Correo eletrónico</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput formControlName="correo_usuario" type="text" />
        </mat-form-field>

        <mat-form-field appearance="legacy" class="password">
          <mat-label>Contraseña</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="password" formControlName="clave_usuario" />
        </mat-form-field>
      </form>
    </div>
    <!-- <div class="forget-pass-container">
      <a class="forget-pass">He olvidado la contraseña</a>
    </div> -->
    <button
      mat-button
      class="btn btn-login"
      type="submit"
      (click)="loginUser(loginForm.value)"
    >
      Iniciar sesión
    </button>
    <!-- <div class="pre-social-media">
      <hr />
      <div class="social-medias">
        <i class="fab fa-facebook"></i>
        <i class="fab fa-google-plus"></i>
        <i class="fab fa-linkedin"></i>
      </div>
    </div> -->
  </div>
  <!-- Fin flujo login -->

  <!-- Inicio flujo registro -->
  <div *ngIf="showRegister">
    <div class="register-container">
      <form [formGroup]="registerForm">
        <!-- <p class="type-account">¿Qué tipo de uso le darás a tu cuenta?</p>
        <div class="btns-type">
          <button
            (click)="getSelection('company')"
            mat-button
            class="btn btn-type-account"
            title="Podrás crear eventos y asignar colaboradores"
          >
            Empresa
          </button>


          <button
            mat-button
            class="btn btn-type-account"
            (click)="getSelection('personal')"
          >
            Personal
          </button>
        </div> -->
        <!-- Inicio 2 Campos juntos -->

        <mat-form-field appearance="legacy" class="names">
          <mat-label>Nombres</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="text" formControlName="nombres_usuario" />
        </mat-form-field>
        <mat-form-field appearance="legacy" class="lastnames">
          <mat-label>Apellidos</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="text" formControlName="apellidos_usuario" />
        </mat-form-field>
        <!-- Fin 2 Campos juntos -->

        <mat-form-field appearance="legacy" class="country">
          <mat-label>País</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <mat-select formControlName="pais_usuario">
            <mat-option value="null">Seleccione un país</mat-option>
            <mat-option *ngFor="let p of paises" [value]="p.name_es">
              {{ p.name_es }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- <mat-form-field
          appearance="legacy"
          *ngIf="showCompanyFields"
          class="company"
        >
          <mat-label>Empresa</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput class="company" type="text"  />
        </mat-form-field> -->
        <!-- <mat-form-field
          appearance="legacy"
          *ngIf="showCompanyFields"
          class="profession"
        >
          <mat-label>Profesión</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="text" />
        </mat-form-field> -->
        <mat-form-field appearance="legacy" class="phone">
          <mat-label>Teléfono</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="tel" formControlName="telefono_usuario" />
        </mat-form-field>
        <mat-form-field appearance="legacy" class="date-of-birth">
          <mat-label>Fecha de nacimiento</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input
            matInput
            type="date"
            formControlName="fecha_de_nacimiento_usuario"
          />
        </mat-form-field>
        <mat-form-field appearance="legacy" class="email">
          <mat-label>Correo eletrónico</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="text" formControlName="correo_usuario" />
        </mat-form-field>
        <mat-form-field appearance="legacy" class="password">
          <mat-label>Contraseña</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="password" formControlName="clave_usuario" />
        </mat-form-field>
        <mat-form-field appearance="legacy" class="passwordConfirm">
          <mat-label>Confirmar Contraseña</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input
            matInput
            type="password"
            formControlName="confirmar_clave_usuario"
          />
        </mat-form-field>
        <mat-checkbox formControlName="checkPolitics"></mat-checkbox>
        <p class="checkPolitics" style="font-family: 'Montserrat' !important;">
          Acepto la política de tratamiento de datos y los términos y
          condiciones de uso
        </p>
      </form>
    </div>
    <button
      (click)="registerUser(registerForm.value)"
      [disabled]="!registerForm.valid && !registerForm.value.checkPolitics"
      mat-button
      class="btn btn-register"
    >
      Crear usuario
    </button>
  </div>

  <!-- Fin flujo registro -->


  <!-- Inicio flujo registro EMPRESA-->
  <div *ngIf="showCompany">
    <div class="register-container">
      <form [formGroup]="empresaForm">
        <!-- <p class="type-account">¿Qué tipo de uso le darás a tu cuenta?</p>
        <div class="btns-type">
          <button
            (click)="getSelection('company')"
            mat-button
            class="btn btn-type-account"
            title="Podrás crear eventos y asignar colaboradores"
          >
            Empresa
          </button>


          <button
            mat-button
            class="btn btn-type-account"
            (click)="getSelection('personal')"
          >
            Personal
          </button>
        </div> -->
       

      
        <mat-form-field appearance="legacy">
          <mat-label>Nombre empresa/colegio</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="text" formControlName="nombre_empresa_usuario" />
        </mat-form-field>
       
        <mat-form-field appearance="legacy" class="email">
          <mat-label>Correo eletrónico</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="text" formControlName="correo_empresa_usuario" />
        </mat-form-field>
        <mat-form-field appearance="legacy" class="phone">
          <mat-label>Teléfono</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="tel" formControlName="telefono_empresa_usuario" />
        </mat-form-field>
        <mat-form-field appearance="legacy">
          <mat-label>Palabra clave para los eventos (subdominio)</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="text" formControlName="subdominio_empresa_usuario" />
        </mat-form-field>
        <!-- <mat-form-field appearance="legacy">
          <mat-label>¿Subdominio activo?</mat-label>
          <mat-icon matPrefix>panorama_fish_eye</mat-icon>
          <input matInput type="text" formControlName="cuenta_activa_subdominio" />
        </mat-form-field> -->

        
        <mat-checkbox formControlName="checkPolitics"></mat-checkbox>
        <p class="checkPolitics" style="font-family: 'Montserrat' !important;">
          Acepto la política de tratamiento de datos y los términos y
          condiciones de uso
        </p>
      </form>
    </div>
    <button
      (click)="addCompany(empresaForm.value)"
      [disabled]="!empresaForm.valid && !empresaForm.value.checkPolitics"
      mat-button
      class="btn btn-register"
    >
      Crear empresa
    </button>
  </div>

  <!-- Fin flujo registro EMPRESA-->
</div>
